import { fetcherServer } from "../services/axiosConfigServer"
import {fetcher} from "../services/axiosConfig"

const STORE_ID = "10"

class DataCollect {
  constructor() {
    this.sessionId = null
    this.fetcher = fetcher
    this.fetcherServer = fetcherServer
    this.store = STORE_ID
  }

  init() {
    const sessionId = this.getLocalSessionId()

    const hasSession = !!sessionId

    return hasSession ? this.setSessionId(sessionId) : this.getNewSessionId()
  }

  async send(location) {
    const sessionId = this.sessionId ? this.sessionId : this.getLocalSessionId()
    const { pathname, search } = location
    const ip = await this.getUserIP()
    const userId = this.getUserInfo().pk
    const body = {
      session_id: sessionId,
      request_path: pathname,
      request_uri: pathname + search,
      store: this.store,
      user_ip: ip,
      person_id: userId,
      origin: 4
    }
    this.getNewRootToken().then(newToken => {
      this.fetcher({
        url: "/datacollect/",
        data: body,
        method: "POST",
        headers: {
          Authorization: `Bearer ${newToken}`,
        },
      })
    })
  }

  setSessionId(id) {
    this.sessionId = id
  }

  async getNewSessionId() {
    this.getNewRootToken().then(newToken => {
      this.fetcher({
        url: "/datacollect/uuid/",
        headers: {
          Authorization: `Bearer ${newToken}`,
        },
      }).then(({ session_id }) => {
        this.setSessionId(session_id)
        localStorage.setItem("session_id", session_id)
      })
    })
  }
  async getUserIP() {
    const ip = await fetch("https://api64.ipify.org?format=json/").then(res =>
      res.text()
    )
    return ip
  }
  getUserInfo() {
    const userInfo = localStorage.getItem("user")
    const userInfoObject = JSON.parse(userInfo);

    return userInfoObject
  }
  async getNewRootToken() {
    return this.fetcherServer({
      url: "/token/",
      method: "POST",
    }).then(({ data }) => data?.access)
  }

  getLocalSessionId() {
    return localStorage.getItem("session_id")
  }

  getSessionId() {
    return this.sessionId
  }
}

const dataCollect = new DataCollect()
export default dataCollect
